export default __webpack_public_path__ + "static/media/7c.ffa810bd.png";